export default __webpack_public_path__ + "static/media/PPI-driveway-001.0ef33034.jpg";